// CustomStatusFilter.tsx
import type { IFilterParams, IFilterComp } from "ag-grid-community";

export class CustomStatusFilterComponent implements IFilterComp {
  private eGui: HTMLElement | null = null;
  private selectedStatus: string | null = null;
  private filterParams: IFilterParams | null = null;
  private statusOptions: { value: string; label: string }[] = [];
  private isInitialized: boolean = false;
  private t: (key: string) => string;

  init(params: IFilterParams): void {
    this.filterParams = params;
    // 获取翻译函数
    this.t =
      window.__t ||
      ((key: string) => {
        const defaultTranslations: Record<string, string> = {
          "admin.waiting": "等待中",
          "admin.processing": "处理中",
          "admin.failed": "失败",
          "admin.success": "成功",
          "common.all": "全部",
        };
        return defaultTranslations[key] || key;
      });

    // 初始化状态选项
    this.statusOptions = [
      { value: "WAITING", label: this.t("admin.waiting") },
      { value: "PROCESSING", label: this.t("admin.processing") },
      { value: "ERROR", label: this.t("admin.failed") },
      { value: "SUCCESS", label: this.t("admin.success") },
    ];

    this.setupGui();
    this.isInitialized = true;
  }

  setupGui(): void {
    this.eGui = document.createElement("div");
    this.eGui.innerHTML = `
            <div style="padding: 8px; min-width: 100px; max-height: 300px; overflow-y: auto;">
                <div style="margin-bottom: 8px;">
                    <label style="display: flex; align-items: center; cursor: pointer;">
                        <input type="radio" name="status-filter" value="" style="margin-right: 8px;" checked />
                        <span>${this.t("common.all")}</span>
                    </label>
                </div>
                <div style="border-top: 1px solid #e0e0e0; padding-top: 8px;" id="status-list">
                    ${this.statusOptions
                      .map(
                        (option) => `
                        <div style="margin-bottom: 6px;">
                            <label style="display: flex; align-items: center; cursor: pointer;">
                                <input type="radio" name="status-filter" value="${option.value}" style="margin-right: 8px;" />
                                <span>${option.label}</span>
                            </label>
                        </div>
                    `
                      )
                      .join("")}
                </div>
            </div>
        `;

    // 绑定事件
    const radios = this.eGui.querySelectorAll('input[type="radio"][name="status-filter"]');
    radios.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        const target = e.target as HTMLInputElement;
        const value = target.value;
        this.handleStatusChange(value || null);
      });
    });

    // 设置默认选中状态
    this.selectedStatus = "";
  }

  handleStatusChange(status: string | null): void {
    // 只有在初始化完成后才处理状态变化
    if (!this.isInitialized) {
      return;
    }

    this.selectedStatus = status;
    this.filterParams?.filterChangedCallback();

    // 触发父组件刷新
    this.triggerParentRefresh();
  }

  triggerParentRefresh(): void {
    // 确保只传递有效的值
    let valueToSend: string | undefined = undefined;

    if (this.selectedStatus && this.selectedStatus !== "") {
      valueToSend = this.selectedStatus; // 传递实际选中的值
    }

    // 通过全局事件触发父组件刷新
    const event = new CustomEvent("filterChanged", {
      detail: {
        field: "state",
        value: valueToSend,
      },
    });
    window.dispatchEvent(event);
  }

  getGui(): HTMLElement {
    return this.eGui as HTMLElement;
  }

  isFilterActive(): boolean {
    return this.selectedStatus !== null && this.selectedStatus !== "";
  }

  doesFilterPass(params: any): boolean {
    if (!this.selectedStatus || this.selectedStatus === "") {
      return true;
    }
    return params.data.state === this.selectedStatus;
  }

  getModel(): any {
    return this.selectedStatus && this.selectedStatus !== "" ? this.selectedStatus : null;
  }

  setModel(model: any): void {
    if (model && typeof model === "string") {
      this.selectedStatus = model;
    } else {
      this.selectedStatus = ""; // 设置为空字符串表示"全部"
    }

    // 更新UI
    const radios = this.eGui?.querySelectorAll('input[type="radio"][name="status-filter"]') || [];
    radios.forEach((radio) => {
      const input = radio as HTMLInputElement;
      input.checked = input.value === (this.selectedStatus || "");
    });
  }

  destroy(): void {
    this.isInitialized = false;
  }
}

export default CustomStatusFilterComponent;
